import React from 'react'

export const ChainLinkIcon = React.forwardRef<SVGSVGElement>((props, ref): React.ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
      <path
        d="M10.3893 12.8054C10.7351 13.2678 11.1764 13.6503 11.6831 13.9272C12.1898 14.204 12.7502 14.3687 13.3261 14.4099C13.9021 14.4512 14.4801 14.3681 15.0211 14.1663C15.5622 13.9644 16.0534 13.6486 16.4616 13.2403L18.8777 10.8242C19.6112 10.0648 20.0171 9.04758 20.0079 7.99178C19.9987 6.93597 19.5753 5.92601 18.8287 5.17941C18.0821 4.43282 17.0721 4.00933 16.0163 4.00015C14.9605 3.99098 13.9433 4.39685 13.1839 5.13036L11.7987 6.50752"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6107 11.1947C13.2649 10.7323 12.8236 10.3497 12.3169 10.0728C11.8102 9.796 11.2498 9.63137 10.6739 9.59012C10.0979 9.54887 9.51987 9.63197 8.97886 9.83378C8.43786 10.0356 7.94659 10.3514 7.53836 10.7598L5.1223 13.1758C4.3888 13.9353 3.98292 14.9525 3.9921 16.0083C4.00127 17.0641 4.42476 18.074 5.17136 18.8206C5.91795 19.5672 6.92791 19.9907 7.98372 19.9999C9.03953 20.0091 10.0567 19.6032 10.8162 18.8697L12.1933 17.4925"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default ChainLinkIcon
